<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col cols="12" md="12">
                <component-header
                    title="Edit Service Request"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/service-request')"
                />
            </b-col>
            <b-col cols="12" md="12">
                <b-card>
                    <b-row>
                        <b-col cols="12" sm="12" md="4">
                            <span>Category</span>
                        </b-col>
                        <b-col cols="12" sm="12" md="8">
                            <c-input
                                inputType="text"
                                labelText="Category"
                                v-model="itemObj.name"
                            />
                        </b-col>
                    </b-row>
                    <b-row
                        v-if="userRole === 'Tenant' || userRole === 'Partner'"
                    >
                        <b-col md="4">
                            <span>Scope</span>
                        </b-col>
                        <b-col md="8">
                            <div class="form-group">
                                <b-form-select
                                    id="type"
                                    v-model="itemObj.scope"
                                    :options="scope1Options"
                                    placeholder="Edit Scope"
                                ></b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="userRole === 'Admin'">
                        <b-col md="4">
                            <span>Scope</span>
                        </b-col>
                        <b-col md="8">
                            <div class="form-group">
                                <b-form-select
                                    id="type"
                                    v-model="itemObj.scope"
                                    :options="scopeOptions"
                                    placeholder="Edit Scope"
                                ></b-form-select>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4">
                            <span>Description</span>
                        </b-col>
                        <b-col md="8">
                            <div class="form-group">
                                <b-form-textarea
                                    v-model="itemObj.description"
                                    placeholder="Enter something..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <span>Severity</span>
                        </b-col>
                        <b-col md="8">
                            <div class="form-group">
                                <b-form-select
                                    id="type"
                                    v-model="itemObj.severity"
                                    :options="severityOptions"
                                    placeholder="Edit Severity"
                                ></b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <span>Status</span>
                        </b-col>
                        <b-col md="8">
                            <div class="form-group">
                                <b-form-select
                                    id="type"
                                    v-model="itemObj.status"
                                    :options="statusOptions"
                                    placeholder="Edit Status"
                                ></b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <div class="text-center mb-3">
                    <eb-button
                        class="btn mr-4"
                        classic="mr-1 btn-primary"
                        text="Update"
                        :disabled="!itemObj.description || !itemObj.name"
                        @click.prevent="handleSubmit"
                    ></eb-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "editrequest",
    components: {
        ebButton,
        cInput,
        ComponentHeader,
        AtomSpinner,
    },
    data: () => {
        return {
            show: true,
            scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
            scopeOptions: ["TENANT"],
            statusOptions: ["Active", "Inactive"],
            severityOptions: ["Low", "Medium", "High", "Critical"],
            scope: "",
            status: "",
            name: "",
            severity: "",
            description: "",
            itemObj: {},
            loading: false,
        };
    },
    computed: {
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
    },
    methods: {
        findItemById(list, id) {
            if (!list || !id) return null;
            return list.find((obj) => (obj._id || obj.id) === id) || null;
        },
        async handleSubmit() {
            if (!this.itemObj.description || !this.itemObj.name) {
                this.$swal({
                    title: "Error",
                    text: "Please fill all Fields.",
                    type: "error",
                });
                return;
            }
            let dataObj;
            dataObj = {
                id: this.itemObj.id,
                data: {
                    scope: this.itemObj.scope,
                    name: this.itemObj.name,
                    severity: this.itemObj.severity,
                    description: this.itemObj.description,
                    status: this.itemObj.status,
                },
            };
            try {
                await this.$store.dispatch(
                    "servicerequest/updateCategory",
                    dataObj,
                );
                this.$swal({
                    title: "Success",
                    text: "Request updated successfully!!",
                    type: "success",
                });
                this.$router.push("/setup/service-request");
                this.$store.dispatch("servicerequest/fetchServicerequestList");
            } catch (error) {
                this.$toasted?.error(
                    error?.message || "Failed to update service request",
                );
            }
        },
    },
    async mounted() {
        const id = this.$route.params.id;
        if (!id) {
            this.$router.replace("/setup/service-request");
            return;
        }
        this.loading = true;
        try {
            let list =
                this.$store.getters["servicerequest/GetServiceRequestList"];
            if (!list || list.length === 0) {
                await this.$store.dispatch(
                    "servicerequest/fetchServicerequestList",
                );
                list =
                    this.$store.getters["servicerequest/GetServiceRequestList"];
            }
            const item = this.findItemById(list, id);
            if (!item) {
                this.$toasted?.error("Service request not found");
                this.$router.replace("/setup/service-request");
                return;
            }
            this.itemObj = { ...item, id: item._id || item.id };
        } catch (error) {
            this.$toasted?.error(
                error?.message || "Failed to load service request",
            );
            this.$router.replace("/setup/service-request");
        } finally {
            this.loading = false;
        }
    },
};
</script>
<style scoped>
.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}
</style>
